/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import Image from 'next/image';
import fa from 'locales/fa.json';
import AntButton from 'components/Common/AntButton';
import { faNumber } from 'utils/common.util';
import LoginLayout from 'components/Common/LoginLayout';
import TeacherLink from 'components/Common/TeacherLink';
import Comments from 'components/Common/Comments';
import Questions from 'components/Common/Questions';
import { EventType } from 'types/course.type';
import OffBadge from 'components/Common/OffBadge';
import DiscountPrice from 'components/Common/DiscountPrice';

const tabs = ['info', 'comments', 'questions'];
const Event: React.FC<{ data: EventType }> = ({ data }) => {
  const [slide, setSlide] = useState('info');

  return (
    <div className="duration-300 bg-gray-0 min-h-screen flex-col flex items-center justify-items-start">
      <div className="xl:pr-[370px] mt-[20px] md:mt-0 w-screen md:w-[700px] py-[20px] xl:pl-[20px]  xl:justify-self-start xl:w-full">
        <div className="w-full bg-white rounded-[8px] min-h-[500px]">
          <h2 className="h-[70px] center w-full font-bold text-[26px] m-[0px]">
            {data?.title}
          </h2>
          <Image
            src={data?.image}
            layout="responsive"
            alt={data?.title}
            width={700}
            height={396}
            priority
          />
          <div
            className="mx-[40px] py-[50px] text-[16px]"
            dangerouslySetInnerHTML={{ __html: data?.description }}
          />
        </div>
      </div>
      <div className="w-screen mb-[20px] overflow-auto toRight rounded-[8px] xl:rounded mt-[20px] xl:mt-0 xl:mb-0 md:w-[700px] relative xl:fixed right-0 bg-white xl:w-[350px] xl:h-[calc(100%-70px)]">
        <div className="h-[55px] center text-[16px] w-full flex flex-row-reverse border-b-gray-1 border-b text-gray-3">
          {tabs.map((item, index) => (
            <span key={item} onClick={(): void => setSlide(item)}>
              <span
                className={`mx-[10px] link ${slide === item && 'font-bold text-black'}`}
              >
                {fa.course[item]}
              </span>
              {index !== 0 && '/'}
            </span>
          ))}
        </div>

        <div className="overflow-auto xl:h-[90%] toRight mb-[40px] xl:mb-0">
          {slide === 'info' && (
            <div className="toLeft px-[40px]">
              <TeacherLink teacher={data?.teachers[0]} />

              <div className="flex w-full justify-between mt-[10px]">
                <div>{fa.webinar.type}</div>
                <div>{fa.global.online}</div>
              </div>

              <div className="flex w-full justify-between mt-[15px]">
                <div>{fa.global.status}</div>
                <div className="text-green-2">{fa.webinar.active}</div>
              </div>

              <div className="flex w-full justify-between mt-[15px]">
                <div>{fa.global.capacity}</div>
                <div>{faNumber(data.capacity)}</div>
              </div>

              {data?.headline && (
                <div className=" w-full mt-[15px]">
                  <div className="font-bold">{fa.webinar.headline}</div>
                  <div className="">
                    {data?.headline.split('\r\n').map((item, index) => (
                      <div className="my-[5px]" key={index}>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {!(data?.link && data?.registered) && (
                <LoginLayout data={data}>
                  <AntButton
                    className="w-full mt-[20px]"
                    display="flex"
                    justifyContent="space-around"
                    disabled={!data.capacity}
                  >
                    <OffBadge off={data.discount} />
                    <DiscountPrice price={data?.price} discount={data?.discount} />
                    <span>{fa.webinar.register}</span>
                  </AntButton>
                </LoginLayout>
              )}
              {data?.link && data?.registered && (
                <AntButton className="w-full mt-[20px]">
                  <a href={data?.link} target="_blank" rel="noreferrer">
                    {fa.webinar.link}
                  </a>
                </AntButton>
              )}

              {!!data?.times.length && (
                <div>
                  <div className="font-bold text-[16px] mt-[20px]">
                    {fa.global.courses}
                  </div>

                  <div className="mb-[30px]">
                    {data?.times.map((time, index) => (
                      <div className="my-[5px]" key={index}>
                        <div className="flex">
                          <div className="font-bold ml-[15px]">
                            {fa.global.course} {faNumber(index + 1)}
                          </div>
                          {time.description && <div>({time.description})</div>}
                        </div>
                        <div className="flex">
                          <div className="ml-[10px]">{fa.global.date}:</div>
                          <div>{faNumber(time.date)}</div>
                          <div className="ml-[10px] mr-[20px]">{fa.global.hour}:</div>
                          <div>
                            {faNumber(time.start)} {fa.webinar.to} {faNumber(time.end)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {slide === 'comments' && (
            <Comments
              register={data?.registered}
              data={data?.comments.data}
              id={data?.id}
              type="events"
            />
          )}
          {slide === 'questions' && (
            <Questions data={data?.questions} register={data?.registered} isEvent />
          )}
        </div>
      </div>
    </div>
  );
};

export default Event;
